import print from "../plugins/printd/index.js";

export const customersMixin = {
    computed: {
        initialData() {
            return this.$store.state.initialData;
        },
    },
    methods: {
        getCustomers() {
            this.axios.get("customers/create").then((res) => {
                this.$store.commit("setInitialData", res.data);
            });
        },
    },
};

export const exchange = {
    methods: {
        exchange(sale_currency, buy_currency, amount, rate) {
            if (!(sale_currency && buy_currency)) return 0;
            if (rate > 1) {
                if (sale_currency.rank < buy_currency.rank)
                    return (amount * rate).toFixed(2) || 0;
                if (sale_currency.rank > buy_currency.rank)
                    return (amount / rate).toFixed(2) || 0;
            } else if (rate && rate < 1 && rate != 0) {
                if (sale_currency.rank < buy_currency.rank)
                    return (amount / rate).toFixed(2) || 0;
                if (sale_currency.rank > buy_currency.rank)
                    return (amount * rate).toFixed(2) || 0;
            }
            return amount;
        },

        getRate(
            from_cur_rank,
            to_cur_rank,
            base_cur_rank,
            from_to_base_rate,
            to_to_base_rate
        ) {
            let saleRate =
                from_to_base_rate >= 1
                    ? from_to_base_rate
                    : 1 / from_to_base_rate;
            let buyRate =
                to_to_base_rate >= 1 ? to_to_base_rate : 1 / to_to_base_rate;
            let result = 1;

            if (
                (from_cur_rank <= base_cur_rank &&
                    to_cur_rank >= base_cur_rank) ||
                (to_cur_rank <= base_cur_rank && from_cur_rank >= base_cur_rank)
            ) {
                result = saleRate * buyRate;
            } else {
                result = saleRate / buyRate;
            }
            if (result < 1) return Number(1 / result).toFixed(5);
            return Number(result).toFixed(5);
        },

        getSaleRate(from_cur_rank, to_cur_rank, base_cur_rank, rate, buy_rate) {
            if (to_cur_rank == base_cur_rank) return rate;
            else if (from_cur_rank == base_cur_rank) return 1;
            rate = rate >= 1 ? rate : 1 / rate;
            buy_rate = buy_rate >= 1 ? buy_rate : 1 / buy_rate;
            let result = 1;
            if (
                (from_cur_rank <= base_cur_rank &&
                    to_cur_rank >= base_cur_rank) ||
                (to_cur_rank <= base_cur_rank &&
                    from_cur_rank >= base_cur_rank) ||
                from_cur_rank <= to_cur_rank
            )
                result = rate / buy_rate;
            else result = rate * buy_rate;
            if (result < 1) return Number(1 / result).toFixed(5);
            return Number(result).toFixed(5);
        },
    },
};

export const printBill = {
    computed: {
        cssText() {
            let lang = { dir: "rtl" };
            if (localStorage.getItem("lang")) {
                lang = JSON.parse(localStorage.getItem("lang"));
            }
            return `
                    body{
                      direction:${lang.dir}
                    }
                    @page{
                      margin:0;
                      size: A4;
                    }
                    .bill {
                      width:196mm;
                      padding: 5mm;
                      min-width: 190mm;
                      min-height: 120mm;
                      position:releative;
                      background-size: 100mm auto;
                      background-repeat: no-repeat;
                      background-position: center center;
                    }
                    .bill_title {
                      font-size:16px;
                      margin-bottom:6px;
                    }
                    .di-flex {
                      display:flex;
                      justify-content: space-between;
                    }
                    .justify-space-around {
                      justify-content: space-around;
                    }
                    .text-xs-left{
                      text-align:left;
                    }
                    .text-xs-right{
                      text-align:right;
                    }
                    .bill-footer {
                      margin-top: 10px;
                    }
                    .bill-footer strong {
                      font-weight: 250;
                    }
                    table.greyGridTable {
                      width: 100%;
                      text-align: left;
                      border-collapse: collapse;
                    }
                    .greyGridTable td, .greyGridTable th {
                      color: #42494f;
                      padding: 3px 8px;
                      border: 0.03px solid #42494f;
                    }
                    td, th{
                      padding: 4px 8px;
                    }
                    .lighten-4{
                      border-color: #f5f5f5!important;
                      background-color: #f5f5f5!important;
                    }
                    .text-xs-center{
                      font-weight: 250;
                      text-align: center !important;
                    }
                    .flex-row {
                      width: 100%;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: center;
                    }

                    .flex-column {
                      width: 100%;
                      align-items: center;
                      justify-content: center;
                      display: flex !important;
                      flex-direction: column !important;
                    }
                    .v-divider{
                      border-color: gray;
                    }
                    .bill_label {
                      text-align: left;
                    }
                    .bill_value {
                      text-align:  left;
                    }
                    .font-weight-bold {
                      font-weight:600;
                    }
                    .font-weight-medium {
                      font-weight:400;
                    }
                    .my-3{
                      margin-top:12px;
                      margin-bottom:12px;
                    }
                    .mt-5{
                      margin-top: 60px !important;
                    }
                    .mb-5{
                      margin-bottom: 60px !important;
                    }
                    .mb-1{
                      margin-bottom:10px;
                    }
                    .mb-2{
                      margin-bottom:16px;
                    }
                    .theme--light.v-divider {
                      border-color: rgba(0,0,0,0.12);
                    }
                    .v-divider {
                      height: 0px;
                      border: solid;
                      flex: 1 1 0px;
                      display: block;
                      max-width: 100%;
                      max-height: 0px;
                      -ms-flex: 1 1 0px;
                      -webkit-box-flex: 1;
                      transition: inherit;
                      border-width: thin 0 0 0;
                      -webkit-transition: inherit;
                    }

                    .print_logo, bill_logo {
                      width: 2cm;
                      height: auto;
                    }
                    
                    .customer-image img {
                      width: 2cm;
                      height: 2cm;
                    }
                    .print-customer-form td {
                      padding: 4px 12px;
                      text-align: left;
                      font-family: IRanSans;
                    }
                    .table-label-white {
                      background-color: white;
                      border: 1px solid white;
                    }
                    .rlr-border {
                      border-left: 0.1px solid white;
                      border-right: 0.1px solid white;
                    }
                    .bill_color {
                      border-color: black !important;      
                      background-color: #42494f !important;
                    }
                    .bill_text_color--text {
                      color: #42494f !important;      
                    }

                    .white--text {
                      color: #fff!important;
                      caret-color: #fff!important;
                    }
                    .white {
                      border-color: #fff!important;
                      background-color: #fff!important;
                    }
                    .capitalize{
                      text-transform: capitalize;
                    }
                    .lr--text {
                      text-align: ${
                          lang.dir == "ltr" ? "left" : "right"
                      } !important;
                    }
                    .row-reversable {
                      display: flex;
                      flex-direction: ${
                          lang.dir == "ltr" ? "row" : "row-reverse"
                      };
                    }
                    .align-start {
                      align-items: ${
                          lang.dir == "ltr" ? "flex-start" : "flex-end"
                      };
                    }
                    .align-end {
                      align-items: ${
                          lang.dir == "ltr" ? "flex-end" : "flex-start"
                      };
                    }
                    .pcf-label {
                      font-size:14px;
                      font-weight: 700;
                      font-family: IRanSans;
                      text-align: ${lang.dir == "ltr" ? "left" : "right"};
                    }
                    .pcf-text {
                      font-size:14px;
                      font-weight: 600;
                      font-family: IRanSans;
                      text-align: ${lang.dir == "ltr" ? "left" : "right"};
                    }
                  `;
        },
    },
    methods: {
        getallcss() {
            let lang = { dir: "rtl" };
            if (localStorage.getItem("lang")) {
                lang = JSON.parse(localStorage.getItem("lang"));
            }
            const allCSS = [...document.styleSheets]
                .map((styleSheet) => {
                    try {
                        return [...styleSheet.cssRules]
                            .map((rule) => rule.cssText)
                            .join("");
                    } catch (e) {
                        console.log(
                            "Access to stylesheet %s is denied. Ignoring...",
                            styleSheet.href
                        );
                    }
                })
                .filter(Boolean)
                .join("\n");
            return (
                allCSS +
                `
            body{
              direction:${lang.dir}
            }
            @page{
              size: A4 landscape; margin: 0.2cm !important;
            }
      `
            );
        },
        isMobileDevice() {
            if (
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)
            ) {
                return true;
            } else {
                return false;
            }
        },
        printBill(element, disablePrint = true, cssText = this.cssText) {
            if (disablePrint) return;
            if (this.isMobileDevice()) {
                let html = "";
                if (element.outerHTML) html = element.outerHTML;
                else if (XMLSerializer)
                    html = new XMLSerializer().serializeToString(element);
                this.$store.commit("ReportsModule/setBillData", {
                    html,
                    css: cssText,
                });
                this.$router.push("/print/bill");
            } else {
                print(element, cssText, disablePrint);
            }
        },
    },
};
